// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Batch clearing execution result'"></sub-header>

  <table class="table" ng-table="\$ctrl.tableConfig">
    <thead>
    <tr>
      <th>No.</th>
      <th>Number</th>
      <th>MICR</th>
      <th>Amount</th>
      <th>Product number</th>
      <th>Product balance</th>
      <th>Product holds balance</th>
      <th>ATA balance</th>
      <th>ATA holds balance</th>
      <th>Cleared successfully</th>
      <th>Clearing errors</th>
      <th>Clearing charges amount</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="item in \$data">
      <td>{{ \$ctrl.getRowNo(\$index) }}</td>
      <td>{{ item.checkNumber }}</td>
      <td>{{ item.micrNumber }}</td>
      <td>{{ item.amount | nxCurrency }}</td>
      <td>{{ item.productNumber }}</td>
      <td>{{ item.productBalance | nxCurrency }}</td>
      <td>{{ item.productHoldsBalance | nxCurrency }}</td>
      <td>{{ item.ataBalance | nxCurrency }}</td>
      <td>{{ item.ataHoldsBalance | nxCurrency }}</td>
      <td ng-class="item.clearedSuccessFully ? 'green' : 'red'">{{ item.clearedSuccessFully | prettyBoolean }}</td>
      <td>{{ \$ctrl.formatClearingErrors(item.clearingErrors) }}</td>
      <td>{{ item.clearingChargesAmount | nxCurrency }}</td>
    </tr>
    </tbody>
  </table>

  <div ng-if="!\$ctrl.tableConfig.data || !\$ctrl.tableConfig.data.length" class="empty-message">
    <span>No checks found for this clearing entry.</span>
  </div>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.goBack()">
      Return
    </button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-clearing-page/batch-clearing-history-list/batch-clearing-history/batch-clearing-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;